
import LoyaltyLevelsService from '../../../services/loyalty/levels'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createLoyaltyLevel ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      LoyaltyLevelsService.createLoyaltyLevel(payload).then(response => { 
        if (response.data && response.data.data._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating loyalty program'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyLevels ({ commit },params) {

    return new Promise((resolve, reject) => { 
      LoyaltyLevelsService.getLoyaltyLevels(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getLoyaltyLevel ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      LoyaltyLevelsService.getLoyaltyLevel(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteLoyaltyLevel ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      LoyaltyLevelsService.deleteLoyaltyLevel(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateLoyaltyLevel ({ commit }, loyaltyLevel) {

    return new Promise((resolve, reject) => { 
      LoyaltyLevelsService.updateLoyaltyLevel(loyaltyLevel).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
}